import { render, staticRenderFns } from "./ScreenLibros.vue?vue&type=template&id=28fb0ef4"
import script from "./ScreenLibros.vue?vue&type=script&lang=js"
export * from "./ScreenLibros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports